import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionProDev = (props) => {
  return (
    <Hoc>
      <CvItem date="Persian">
        <CvItemDesc descBold="Native" />
      </CvItem>

      <CvItem date="English">
        <CvItemDesc descBold="Professional Proficiency">
          <CvItemDetail primary bold>
            (10 Feb 2018) - IELTS - General Training :
          </CvItemDetail>
          <CvItemDetail>
            Band&nbsp;Score:&nbsp;7.5 (&nbsp;L:&nbsp;7.5&nbsp;R:&nbsp;8.5&nbsp;W:&nbsp;7&nbsp;S:&nbsp;7&nbsp;)
          </CvItemDetail>
          <CvItemDetail primary bold>
            (16 Dec 2017) - IELTS - General Training : 
          </CvItemDetail>
          <CvItemDetail >
            Band&nbsp;Score:&nbsp;7.5 (L:&nbsp;8.5&nbsp;R:&nbsp;8.5&nbsp;W:&nbsp;6.5&nbsp;S:&nbsp;7)
          </CvItemDetail>
          <CvItemDetail primary bold>
            (29 Jan 2011) - TOEFL - iBT : 
          </CvItemDetail>
          <CvItemDetail >
            Total&nbsp;Score:&nbsp;98 (R:&nbsp;25&nbsp;L:&nbsp;29&nbsp;S:&nbsp;22&nbsp;W:&nbsp;22)
          </CvItemDetail>
        </CvItemDesc>
      </CvItem>

      <CvItem date="Deutsch">
        <CvItemDesc descBold="Intermediate Level (B1.2)" descComment="Learning..." />
      </CvItem>

      <CvItem date="Dutch">
        <CvItemDesc descBold="Basic Understanding" />
      </CvItem>
    </Hoc>
  );
};

export default cvSectionProDev;
